(function () {
  'use strict';

  /* @ngdoc object
   * @name generalFlightReport
   * @description
   *
   */
  angular
    .module('generalFlightReport', [
      'ui.router'
    ]);
}());
